<template>
  <b-modal
    id="modal-image-guide"
    title-class="page-overlay__content-header page-overlay__content-header--no-margin"
    body-class="page-overlay__content-text page-overlay__content-text--long-text"
    scrollable
    ok-only
    ok-title="Close"
    button-size="sm"
    title="Image Guide"
  >
    <hr class="mt-0" />
    <p class="text-center">
      This is the short version. See the full-text version here:
      <strong
        ><router-link to="/image-guidelines"
          >Image Guidelines</router-link
        ></strong
      >
    </p>
    <hr class="mb-0" />
    <div class="info-card__body">
      <div class="info-card__text--one-col pt-0">
        <p class="font-weight-bold my-3">
          Your Image Should Satisfy These Guidelines:
        </p>
        <ul class="list list--bg-very-light-gray">
          <li>
            <p class="font-weight-bold mb-1">Proper Image Size & Resolution</p>
            <p class="px-4">
              Minimum 1000px in height and width. 2000px and higher is better.
            </p>
            <p class="px-4">File size 2MB to 10MB.</p>
            <p class="px-4">
              Photos taken with a modern smart phone or tablet are probably
              good-to-go re: these size requirements!
            </p>
          </li>
          <li class="bg-very-light-gray">
            <p class="font-weight-bold mb-1">
              Orientation: Landscape or Portrait?
            </p>
            <p class="px-4">
              Both okay, prefer landscape (width greater than height).
            </p>
          </li>
          <li>
            <p class="font-weight-bold mb-1">Good Composition</p>
            <p class="px-4">
              The dog should be prominently featured in the image's foreground.
            </p>
            <p class="px-4">
              And the photo should be a single image, i.e. no composite images
              or collages.
            </p>
          </li>
          <li>
            <p class="font-weight-bold mb-1">Excellent Lighting</p>
            <p class="px-4">
              Overall, image should be bright and light (but not over-exposed).
            </p>
          </li>
          <li>
            <p class="font-weight-bold mb-1">In Focus</p>
            <p class="px-4">
              Make sure your dog is clearly in focus. This does NOT mean you
              can't have a "depth of field" effect where the background is
              slightly blurred. That's okay, as long as the dog is focused.
            </p>
          </li>
          <li>
            <p class="font-weight-bold mb-1">
              Photo is Free of Overlays, Text, Graphics, etc.
            </p>
            <p class="px-4">Just a plain image.</p>
          </li>
          <li>
            <p class="font-weight-bold mb-1">
              Subject of Photo is a Dog (or Dogs)!
            </p>
            <p class="px-4">Enough said! =)</p>
            <p class="px-4">And no people please!</p>
          </li>
          <li>
            <p class="font-weight-bold mb-1">Let's See Your Dog's Face</p>
            <p class="px-4">
              Your dog's face should be visible - either facing the camera, a
              3/4 view, or a profile.
            </p>
          </li>
          <li>
            <p class="font-weight-bold mb-1">Text Description Matches Photo</p>
            <p class="px-4">
              The text you submit with your photo must "match" what's
              <span class="italic">in</span> the photo.
            </p>
          </li>
        </ul>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ImageGuideModal',
};
</script>

<style>
</style>